export default "__VITE_ASSET__DI3kDd1c__"